<template>
  <div class="ziyuan_body">
    <van-search v-model="value" placeholder="请输入搜索关键词"/>

    <van-tabs v-model="active" @click="getdata()">
      <van-tab v-for="items in typeslists" :key="items.id" :title="items.titles">
        <!--{{items.id}}-->
      </van-tab>
    </van-tabs>

    <div class="kecheng">
      <van-empty description="暂时没有视频！" v-if="this.list==null || this.list.length==0"/>
      <div class="neirong" v-for="item in list" @click="xiangqing(item)">
        <div :txt="active!=0?'老师:'+item.teacher:''"><img :src="item.covermap"></div>

        <div style="height: 80px">
          <div style="line-height: 200%; width: 100%; padding: 0 8px; font-size: 11pt;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">
            {{item.titles}}
          </div>

          <div class="biaoqian" v-for="itemss in item.tag">
            <div>
              <van-tag type="success">{{itemss}}</van-tag>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Resource",
    data() {
      return {
        active: '',
        value: '',
        list: [],
        typeslists: [],

      }
    },
    created() {
      this.getdata()

    },
    methods: {
      //详情
      xiangqing(item) {
        if (this.active != 0) {
          this.$router.push({path: '/bank', query: {id: item.id}})
        } else {
          this.$router.push({path: '/group', query: {id: item.id}})
        }

      },
      getdata() {
        var that = this;
        this.myrequest({
          url: '/client/getresourcebank.action',
          types: 'get',
          data: {
            // token:this.$store.state.token,
            typesid: this.typeslists.length != 0 ? this.typeslists[this.active].id : ''
          },
          succ: function (res) {
            that.list = res.data
            that.typeslists = res.typeslist
          },
          errs: function (msg) {

          }
        })
      }
    }
  }
</script>

<style scoped lang="stylus">
  .ziyuan_body {
    width 100%;

    .myhoder {
      width 100%
      height 40px
      line-height 40px
    }

    >>> .van-tabs__line {
      background-color #0AC1BA
    }

    .biaoqian {
      div {
        float right;
        margin-right 10px;
        margin-top 5px;

      }
    }

    >>> .van-tag--success {
      background-color #0AC1BA
      border-radius 5px;
    }

    .kecheng {
      width 100%;
      margin 10px auto;
    }

    .neirong {
      overflow hidden
      border-radius 5px;
      width calc(50% - (10px * 3) / 2);
      background-color #fafafa;
      height auto;
      float left;
      /*text-align center*/
      margin-left 10px;
      margin-bottom 15px;
      /*margin-right 10px;*/
      box-shadow: 0px 0px 6px rgba(0, 0, 0, .15);

      > div:first-child {
        position relative
      }

      > div:first-child::before {
        background rgba(0, 0, 0, .5)
        width 100%;
        height 100%;
        position absolute
        top 0
        left 0
        content ""
        text-align right
      }

      > div:first-child::after {
        content attr(txt)
        position absolute
        bottom 10px
        right 10px
        color #fff
      }

      img {
        width 100%;
        /*border-radius 10px;*/
        /*box-shadow: 5px 5px 5px rgba(0,0,0,.5);*/
      }

      div {
        color #333333
      }

      > div:nth-of-type(2) {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Resource.vue